<template>
  <layout>
    <rdkm-title>
      {{ $t('Рассылки') }}
      <router-link tag="span" to="/mailings/add">
        <b-button class="float-right" right size="sm" variant="primary">
            <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
        </b-button>
      </router-link>
    </rdkm-title>
    <div class="tile">
      <filter-form :subject="query.subject"
                   :createDateFrom="query.createDateFrom"
                   :createDateTo="query.createDateTo"
                   :sentDateFrom="query.sentDateFrom"
                   :sentDateTo="query.sentDateTo"
                   :type="query.type"
                   :status="query.status"
                   v-on:search="$refs.grid.filter($event, true)">
      </filter-form>
      <rdkm-grid ref="grid" :state="query"
        :url-prefix="'pmdd'">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>
        <grid-column name="COPY" :url="(row) => `/mailings/copy/${row.id}`" :tooltipTitle="'Сделать копию'" cell="edit-cell"></grid-column>
        <grid-column name="subject" :title="$t('Заголовок')"></grid-column>
        <grid-column name="to" width="300" :title="$t('Получатели')"></grid-column>
        <grid-column name="type_name" width="200" :title="$t('Тип')"></grid-column>
        <grid-column name="status_name" width="160" :title="$t('Статус')"></grid-column>
        <grid-column
          :title="$t('Дата отправки')"
          width="180"
          name="sent_date"
          :format="date => date ? moment(date).format('DD.MM.YYYY HH:mm') : ''"
        ></grid-column>
        <grid-column
          :title="$t('Дата создания')"
          width="180"
          name="create_date"
          :format="date => date ? moment(date).format('DD.MM.YYYY HH:mm') : ''"
        ></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";
import FilterForm from "./Filter.vue";

export default {
  name: "Mailings",
  props: ["query"],
  components: {
    "filter-form": FilterForm, 
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
